import React from 'react';
import {connect} from 'react-redux';
import NoActiveCruiseNotice from "./NoActiveCruisesNotice";
import {getCruisesInfo} from "../utils/cruiseUtils";
import {formatCruiseStartDate} from "../utils/dateTimeUtils";
import { Trans } from '@lingui/react';


class CruisesOverview extends React.Component {
    render() {
        if(!this.props.cruises) {
            return null;
        }

        if (this.props.cruises.length === 0) {
            return (
                <NoActiveCruiseNotice />
            )
        }

        const cruisesInfo = getCruisesInfo(this.props.cruises.cruiseDetails);
        const cruiseStart = formatCruiseStartDate(cruisesInfo.cruiseStart);
        const cruiseDuration = cruisesInfo.cruiseDuration;
        const shipName = cruisesInfo.shipName;

        return (
            <div className="my-4">
                <div className="text-3xl">
                    <span className="text-grey-darker text-lg">{this.props.preText}</span>
                    {cruisesInfo.cruiseName}
                </div>
                <div className="text-grey-darker mt-2">
                    <Trans
                        id="cruise_overview_text"
                        message="{cruiseStart}, {cruiseDuration} nights on {shipName}"
                        values={{ cruiseStart, cruiseDuration, shipName }}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    if(ownProps.cruisesSnapshot) {
        return {
            cruises: ownProps.cruisesSnapshot,
        }
    }

    return {
        cruises: (state.cruises ? state.cruises : null),
    };
}

export default connect(mapStateToProps) (CruisesOverview);